import React, { useEffect } from 'react';
import HeroReselling from '../components/TechReselling/HeroReselling';
import LearnMoreReselling from '../components/TechReselling/LearnMoreReselling';
import ContactSection from '../components/layout/ContactSection';
import Footer from '../components/layout/footer';

const TechReselling = () => {
useEffect(() => {
  const handleContextMenu = (e) => e.preventDefault();
  
  const handleKeyDown = (e) => {
    if (
      e.keyCode === 123 || // F12
      (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || // Ctrl+Shift+I / J
      (e.ctrlKey && e.keyCode === 85) // Ctrl+U
    ) {
      e.preventDefault();
    }
  };

  document.addEventListener("contextmenu", handleContextMenu);
  document.addEventListener("keydown", handleKeyDown);

  return () => {
    document.removeEventListener("contextmenu", handleContextMenu);
    document.removeEventListener("keydown", handleKeyDown);
  };
}, []);
  return (
    <div className="min-h-screen text-white pt-2">
        <section id="HeroReselling" className="scroll-mt-24">
            <HeroReselling />
        </section>
        <section id="LearnMore" className="scroll-mt-24">
            <LearnMoreReselling />
        </section>     
        <section id="contact-us">
          <ContactSection />
        </section>  
        <section id="Footer">
            <Footer />
        </section>
        
    </div>
  );
};

export default TechReselling;


